import { useOutletContext } from "react-router-dom";
import Home from "./Home";
import Profile from "../users/Profile";
import Details from "./components/Details";

function RouteMap(props) {
  const { profile, theme } = useOutletContext();
  const composite = {
    home: <Home theme={theme} profile={profile} />,
    profile: <Profile theme={theme} profile={profile} />,
    detail: <Details theme={theme} profile={profile} />,
  };
  return <>{composite[props.component]}</>;
}
export default RouteMap;